var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_vm._l((_vm.content),function(item,i){return _c('button',{key:i,staticClass:"btn",style:(_vm.color(i)),domProps:{"innerHTML":_vm._s(item)},on:{"click":function($event){return _vm.setCurrent(i)}}})}),_c('div',{staticClass:"bottom-block",style:(_vm.backgroundColor)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }